export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14520.7610dbf4.jpg";